import React, { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { notify } from 'helpers/notificationHelper';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';

// Settings page components
import FormField from 'layouts/pages/account/components/FormField';

// Data
import { useFormik } from 'formik';
import * as yup from 'yup';
import { postTagGroup } from 'services/api/general/tagGroup.js';
import Divider from '@mui/material/Divider';

const validationSchema = yup.object({
    name: yup
        .string('Tag grup adı zorunludur.')
        .min(3, '3 karakterden fazla olmalıdır')
        .max(200, '200 karakterden az olmalıdır')
        .required('Tag grup adı zorunludur.'),
    description: yup.string('Açıklama Alanı').max(200, '200 karakter olmalıdır'),
});

export default function AddTagGroup({ setOpenDialog }) {
    const queryClient = useQueryClient();
    const [disableOnSubmit, setDisableOnSubmit] = useState(false);

    const formik = useFormik({
        initialValues: {
            name: '',
            description: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            setDisableOnSubmit(true);

            postTagGroup(values)
                .then((rp) => {
                    queryClient.invalidateQueries({ queryKey: ['allTagGroups'] });
                    notify(rp.data.success, rp.data.message);
                    setDisableOnSubmit(false);
                    setOpenDialog(false);
                })
                .catch((error) => {
                    notify(false, JSON.stringify(error));
                    setDisableOnSubmit(false);
                });
        },
    });

    return (
        <Card id="basic-info" sx={{ overflow: 'visible' }}>
            <form onSubmit={formik.handleSubmit}>
                <MDBox p={3}>
                    <Grid container spacing={3}>
                        <Grid size={12}>
                            <MDTypography variant="h6" color="secondary">
                                Yeni Tag Grubu Oluştur
                            </MDTypography>
                            <Divider />
                        </Grid>
                        <Grid size={12}>
                            <FormField
                                label="Tag Grup Adı"
                                placeholder="Tag grup adı giriniz"
                                id="name"
                                name="name"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                error={formik.touched.name && Boolean(formik.errors.name)}
                                helperText={formik.touched.name && formik.errors.name}
                            />
                        </Grid>
                        <Grid size={12}>
                            <FormField
                                label="Tag Grup Açıklaması"
                                placeholder="Açıklama giriniz"
                                id="description"
                                name="description"
                                value={formik.values.description}
                                onChange={formik.handleChange}
                                error={formik.touched.description && Boolean(formik.errors.description)}
                                helperText={formik.touched.description && formik.errors.description}
                            />
                        </Grid>
                        <Grid size={12}>
                            <MDButton
                                fullWidth
                                variant="gradient"
                                color="dark"
                                type="submit"
                                disabled={disableOnSubmit}
                            >
                                Tag Grubunu Ekle
                            </MDButton>
                        </Grid>
                    </Grid>
                </MDBox>
            </form>
        </Card>
    );
}
